import React, { useState, memo } from 'react';

interface PersonAvatarProps {
  name: string;
  imageUrl?: string;
  className?: string;
}

const PersonAvatar: React.FC<PersonAvatarProps> = memo(({ name, imageUrl, className }) => {
  const [imageError, setImageError] = useState(false);

  // Get initials from name, handle empty name case
  const getInitials = (fullName: string): string => {
    if (!fullName || fullName.trim() === '') {
      return 'NN'; // No Name
    }
    
    return fullName
      .trim()
      .split(' ')
      .filter(part => part.length > 0) // Filter out empty parts
      .map(part => part.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  // Use consistent gradient color for all avatars - matching Teams design
  const getAvatarGradient = (): string => {
    return 'bg-gradient-to-br from-slate-400 to-slate-500 dark:from-slate-500 dark:to-slate-600';
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const shouldShowImage = imageUrl && !imageError;

  return (
    <div className="relative flex-shrink-0 w-full h-full">
      {shouldShowImage ? (
        <img 
          src={""} 
          alt={name || "No Name"}
          className="w-full h-full rounded-xl object-cover"
          onError={handleImageError}
        />
      ) : (
        <div className={`w-full h-full rounded-lg flex items-center justify-center text-white font-semibold text-sm ${getAvatarGradient()} ${className}`}>
          {getInitials(name)}
        </div>
      )}
    </div>
  );
});

export default PersonAvatar; 